import CommonModal from "@components/ui-components/modal";
import { Controller } from "react-hook-form";
import Flex from "@components/ui-components/flex";
import ImageWrapper from "@components/ui-components/image-wrapper.jsx";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

export const SCOPE_OPTIONS = [
    {
        label: "Grant email permission",
        desc : "Allow access to your email information",
        value: "access_email",
        icon : "auth/gmail.png"
    },
    {
        label: "Grant calendar permission",
        desc : "Allow access to your calendar events",
        value: "access_calendar",
        icon : "auth/g-calendar.png"
    }
];

const GrantPermissionsModal = ({
    isOpen,
    handleSubmit,
    handleModal,
    loading,
    methods
}) => {
    
    const {
        control,
        formState: { errors }
    } = methods;
    const { t } = useTranslation();
    
    return (
        <CommonModal
            isOpen={isOpen}
            handleModal={handleModal}
            title="Email And Calendar Permissions"
            loading={loading}
            confirmButton={{
                txt     : "Login",
                color   : "primary",
                onClick : handleSubmit,
                disabled: loading
            }}
            body={
                <Flex column gap={2}>
                    <Controller
                        name="permissions"
                        control={control}
                        render={({ field: { value = [], onChange } }) => {
                            const togglePermission = perm => {
                                const updated = value.includes(perm) ? value.filter(p => p !== perm) : [...value, perm];
                                onChange(updated);
                            };
                            return (
                                <>
                                    {SCOPE_OPTIONS.map(
                                        ({ value: val, label, desc, icon }) => (
                                            <Flex
                                                key={val}
                                                align="center"
                                                className={classNames(
                                                    "cursor-pointer border rounded p-1 mb-1 w-100",
                                                    {
                                                        "bg-light-primary":
                                                            value.includes(val)
                                                    }
                                                )}
                                                gap={2}
                                                onClick={() => togglePermission(val)
                                                }>
                                                <input
                                                    type="checkbox"
                                                    checked={value.includes(
                                                        val
                                                    )}
                                                    readOnly/>
                                                <Flex
                                                    align="center"
                                                    className="fw-bold gap-1">
                                                    <ImageWrapper
                                                        width={23}
                                                        src={icon}
                                                        className="img-fluid"
                                                        id={label}/>
                                                    <div>
                                                        <p>
                                                            {t(label)}</p>
                                                        <span className="text-muted">
                                                            {t(desc)}
                                                        </span>
                                                    </div>

                                                </Flex>
                                            </Flex>
                                        )
                                    )}
                                </>
                            );
                        }}/>
                    {errors.permissions && (
                        <div className="text-white bg-light-danger text-center p-1 mt-1 w-100">
                            {t(errors.permissions.message)}
                        </div>
                    )}
                </Flex>
            }
            type="small"
            modalColor="secondary"
            hideClose={false}
            modalBodyClassName="p-1">
            <div className="text-muted mb-3">
                {t(
                    "Select options to allow this application to access your Google account information."
                )}
            </div>
        </CommonModal>
    );
};

export default GrantPermissionsModal;
